














































































































import Vue from 'vue'
import Component from 'vue-class-component'
import { getModule } from 'vuex-module-decorators'
import Card from '@/components/Card.vue'
import Switcher from '@/components/Switcher.vue'
import Icon from '@/components/Icon.vue'
import { ChainModule } from '@/store/modules/chain.module'
import { CONSTANTS, EOrigin, IUser, IUserChainRole } from '@zunta/configurations'
import { UserModule } from '@/store/modules/user.module'
import AddChainModal from '../../../components/AddChainModal.vue'
import { Debounce } from 'vue-debounce-decorator'
import TextareaV2 from '@/components/inputsV2/TextareaV2.vue'

const { SALES_REP_ROLE_NAME } = CONSTANTS

@Component({
  components: {
    TextareaV2,
    Card,
    Switcher,
    Icon,
    AddChainModal
  }
})
export default class ChainDetails extends Vue {
  chainModuleInstance: ChainModule = getModule(ChainModule, this.$store)
  userModuleInstance: UserModule = getModule(UserModule, this.$store)
  updatingChain: boolean = false

  get chain () {
    return this.$store.state.chain.chain
  }

  get salesReps () {
    return this.$store.state.user.users.filter((user: IUser) => (
      (user.role as IUserChainRole).name === SALES_REP_ROLE_NAME
    ))
  }

  get chainAdminManager () {
    return this.$store.state.user.selectedUser
  }

  async changeAllowToViewSystem (value: boolean) {
    await this.chainModuleInstance.changeAllowToViewSystem({
      id: this.chain.id,
      AllowToViewSystem: value
    })
  }

  getChainBillingSoftwareLabel () {
    if (this.chain) {
      switch (this.chain.billingSoftware) {
        case 'BOTH':
          return 'PCC, NCS'
        case EOrigin.PCC:
          return 'PCC'
        case EOrigin.NCS:
          return 'NCS'
        case EOrigin.MANUAL:
          return 'Manual'
        default:
          return ''
      }
    }
  }

  closeUpdatingChain () {
    this.updatingChain = false
    this.chainModuleInstance.fetchChain({
      id: this.chain.id,
      relations: ['salesRepresentative', 'accountManager']
    })
  }

  @Debounce(500)
  async updateComments () {
    await this.chainModuleInstance.updateChain({
      id: this.chain.id,
      data: {
        comments: this.chain.comments
      }
    })
  }
}
